export default __webpack_public_path__ + "139555ac406acd5f9df0552bd5629656.svg";